import { LEAD_STATUS, LEAD_SOURCE, LEAD_INTEREST, PRIORITY, DEAL_STAGE, TASK_STATUS, ACTIVITY_TYPE } from "./enums";

export const LEAD_STATUS_LABELS = {
  [LEAD_STATUS.NEW]: { de: "Neu", tone: "new" },
  [LEAD_STATUS.QUALIFYING]: { de: "In Prüfung", tone: "info" },
  [LEAD_STATUS.CONTACTED]: { de: "Kontaktiert", tone: "info" },
  [LEAD_STATUS.DEMO_SCHEDULED]: { de: "Demo geplant", tone: "info" },
  [LEAD_STATUS.OFFER_REQUESTED]: { de: "Angebot angefragt", tone: "warning" },
  [LEAD_STATUS.WON]: { de: "Gewonnen", tone: "success" },
  [LEAD_STATUS.LOST]: { de: "Verloren", tone: "destructive" },
  [LEAD_STATUS.NURTURE]: { de: "Nurturing", tone: "muted" },
};

export const LEAD_SOURCE_LABELS = {
  [LEAD_SOURCE.WEBSITE]: "Website",
  [LEAD_SOURCE.DEMO_REQUEST]: "Öffentliche Anfrage",
  [LEAD_SOURCE.CONTACT_FORM]: "Kontaktformular",
  [LEAD_SOURCE.WHITEPAPER]: "Whitepaper",
  [LEAD_SOURCE.LINKEDIN]: "LinkedIn",
  [LEAD_SOURCE.GOOGLE_ADS]: "Google Ads",
  [LEAD_SOURCE.FAIR]: "Messe",
  [LEAD_SOURCE.MANUAL]: "Manuell",
  [LEAD_SOURCE.OTHER]: "Sonstiges",
};

export const LEAD_INTEREST_LABELS = {
  [LEAD_INTEREST.OPTIMES_DEMO]: "OptiMES Prime Demo",
  [LEAD_INTEREST.CONSULTING]: "Beratung",
  [LEAD_INTEREST.OFFER]: "Angebot",
  [LEAD_INTEREST.CALLBACK]: "Rückruf",
  [LEAD_INTEREST.WHITEPAPER]: "Whitepaper",
  [LEAD_INTEREST.WEBINAR]: "Webinar",
  [LEAD_INTEREST.OTHER]: "Sonstiges",
};

export const PRIORITY_LABELS = {
  [PRIORITY.LOW]: { de: "Niedrig", tone: "muted" },
  [PRIORITY.MEDIUM]: { de: "Mittel", tone: "info" },
  [PRIORITY.HIGH]: { de: "Hoch", tone: "destructive" },
};

export const DEAL_STAGE_LABELS = {
  [DEAL_STAGE.NEW_LEAD]: "Bedarf erkannt",
  [DEAL_STAGE.QUALIFICATION]: "Bedarf erkannt",
  [DEAL_STAGE.FIRST_CONTACT]: "Erstkontakt erfolgt",
  [DEAL_STAGE.DEMO_PLANNED]: "Demo geplant",
  [DEAL_STAGE.NEEDS_ANALYSIS]: "Bedarf analysiert",
  [DEAL_STAGE.OFFER_SENT]: "Angebot versendet",
  [DEAL_STAGE.FOLLOW_UP]: "Nachfassen",
  [DEAL_STAGE.WON]: "Gewonnen",
  [DEAL_STAGE.LOST]: "Verloren",
};

export const DEAL_STAGE_ORDER = [
  DEAL_STAGE.QUALIFICATION,
  DEAL_STAGE.FIRST_CONTACT,
  DEAL_STAGE.DEMO_PLANNED,
  DEAL_STAGE.NEEDS_ANALYSIS,
  DEAL_STAGE.OFFER_SENT,
  DEAL_STAGE.FOLLOW_UP,
  DEAL_STAGE.WON,
  DEAL_STAGE.LOST,
];

export const DEAL_CONVERSION_STAGE_ORDER = [
  DEAL_STAGE.QUALIFICATION,
  DEAL_STAGE.FIRST_CONTACT,
  DEAL_STAGE.DEMO_PLANNED,
  DEAL_STAGE.NEEDS_ANALYSIS,
];

export function normalizeDealStageForWorkflow(stage) {
  return stage === DEAL_STAGE.NEW_LEAD ? DEAL_STAGE.QUALIFICATION : stage;
}

export const TASK_STATUS_LABELS = {
  [TASK_STATUS.OPEN]: { de: "Offen", tone: "new" },
  [TASK_STATUS.IN_PROGRESS]: { de: "In Bearbeitung", tone: "info" },
  [TASK_STATUS.DONE]: { de: "Erledigt", tone: "success" },
  [TASK_STATUS.CANCELLED]: { de: "Abgebrochen", tone: "muted" },
};

export const ACTIVITY_TYPE_LABELS = {
  [ACTIVITY_TYPE.NOTE]: { de: "Notiz", icon: "FileText" },
  [ACTIVITY_TYPE.EMAIL]: { de: "E-Mail", icon: "Mail" },
  [ACTIVITY_TYPE.CALL]: { de: "Anruf", icon: "Phone" },
  [ACTIVITY_TYPE.MEETING]: { de: "Termin", icon: "Calendar" },
  [ACTIVITY_TYPE.DISCUSSION]: { de: "Meeting / Besprechung", icon: "Users" },
  [ACTIVITY_TYPE.OTHER]: { de: "Sonstiges", icon: "CircleDot" },
  [ACTIVITY_TYPE.TASK_CREATED]: { de: "Aufgabe erstellt", icon: "CheckSquare" },
  [ACTIVITY_TYPE.STATUS_CHANGE]: { de: "Statuswechsel", icon: "GitBranch" },
  [ACTIVITY_TYPE.FORM_SUBMISSION]: { de: "Formular eingegangen", icon: "Inbox" },
};

export const ROLE_LABELS = {
  SUPER_ADMIN: "Super-Admin",
  TENANT_ADMIN: "Mandant-Admin",
  SALES_USER: "Vertrieb",
  VIEWER: "Leser",
};

export const CONSENT_SOURCE_LABELS = {
  public_form: "Öffentliches Formular",
  crm_manual: "CRM manuell",
  system_admin: "System",
  consent_management_page: "Einwilligungsseite",
  lead_to_contact_conversion: "Lead-Übernahme",
  migration_backfill: "Übernahme aus Bestandsdaten",
  withdrawal_link: "Widerrufslink",
};

export function getConsentSourceLabel(source) {
  return CONSENT_SOURCE_LABELS[source] || source || "";
}

export const CONSENT_TYPE_LABELS = {
  marketing_communication: "Marketing-Kommunikation",
  email_tracking: "E-Mail-Tracking",
  privacy_request_processing: "Verarbeitung der Anfrage",
};

export function getConsentTypeLabel(type) {
  if (!type) return "Unbekannter Einwilligungstyp";
  return CONSENT_TYPE_LABELS[type] || "Unbekannter Einwilligungstyp";
}
